import React from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../../hooks/typography';

import styles from './styles.module.css';

export const Description: React.FunctionComponent<unknown> = (props) => {
    const typographyCls = useTypography({
        size: TypographySize.BodyS,
        noDefaultColor: true,
    });

    return <p {...props} className={classNames(typographyCls, styles.description)} />;
};
